// extracted by mini-css-extract-plugin
export default {"textCard":"textCard_textCard__N7Rko"};